export const giftBucketsInitialState = {
	entities: {},
};



// WEBPACK FOOTER //
// ./src/redux/giftBuckets/giftBucket.initialState.js